// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueLazyload from "vue-lazyload";
import ViserVue from "viser-vue";
import { Upload, Dialog } from "element-ui";
import App from "./App";
import router from "./router";
import "lib-flexible/flexible";
import "@/assets/css/iconfont.css";
import "@/assets/css/common.css";
import "c-swipe/dist/swipe.css";
import animated from "animate.css";
import { Swipe, SwipeItem } from "c-swipe";
import VueScroller from "vue-scroller";
import Toast from "./components/common/toast";
import VueClipboard from "vue-clipboard2";
let loadImg = require("./assets/img/common/load-default.png");

Vue.config.productionTip = false;

Vue.use(VueLazyload, {
  loading: loadImg, //加载过程中的过渡图片
});
Vue.use(ViserVue);
Vue.use(VueScroller);
Vue.use(animated);
Vue.use(Upload);
Vue.use(Dialog);
Vue.use(VueClipboard);

Vue.component("Toast", Toast);
Vue.component("swipe", Swipe);
Vue.component("swipe-item", SwipeItem);

Vue.config.ignoredElements = ["wx-open-launch-weapp"];

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  template: "<App/>",
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js